
import styled from 'styled-components';
import { Image } from '@/shared/ui/image/Image';

const SideMenuContainer = styled.div<{ $isOpen: boolean, $isViewMenu: boolean  }>`
  display:${props => props.$isViewMenu ? 'flex' : "none"};
  flex-direction: column;
  width: ${props => props.$isOpen ? "320px" : "76px"};
  position: fixed;
  left: var(--app-safe-area-left);
  top: calc(var(--app-header-height) + var(--app-safe-area-top));
  height: calc(100dvh - var(--app-header-height) - var(--app-safe-area-top));
  z-index: 99;
`;

const MenuContent = styled.div<{ $isOpen: boolean }>`
  background: #000;
  height: calc(100dvh - var(--app-header-height) - var(--app-safe-area-top));
  padding: ${props => props.$isOpen ? "18px 16px" : "18px 8px"};
  padding-bottom: calc(18px + var(--app-safe-area-bottom));
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
`;
const SkeletonLoaderWrapper = styled.div<{ $isOpen?: boolean }>`
  width: ${props => props.$isOpen ? '320px' : '76px'};
  height: 100dvh;
  position: fixed;
  left: var(--app-safe-area-left);
  top: var(--app-safe-area-top);
  z-index: 100;
  pointer-events: none;

  @media (max-width: 768px) {
    display: none;
  }
`;

const LogoImage = styled(Image)`
  width: ${({ width }) => width || '30px'};
  height: ${({ height }) => height || '30px'};
  flex-shrink: 0;

  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export { SideMenuContainer, MenuContent, SkeletonLoaderWrapper, LogoImage }
